import {format} from 'date-fns';
import {fromZonedTime, toZonedTime} from 'date-fns-tz';

export const US_TIMEZONE_OPTIONS = [
  { label: 'Eastern Time (ET)', value: 'America/New_York' },
  { label: 'Central Time (CT)', value: 'America/Chicago' },
  { label: 'Mountain Time (MT)', value: 'America/Denver' },
  { label: 'Pacific Time (PT)', value: 'America/Los_Angeles' },
  { label: 'Alaska Time (AKT)', value: 'America/Anchorage' },
  { label: 'Hawaii Time (HT)', value: 'Pacific/Honolulu' },
];

export function getTimezoneAbbreviation(timezoneValue: string): string {
  const match = US_TIMEZONE_OPTIONS.find(opt => opt.value === timezoneValue);
  return match?.label.match(/\(([^)]+)\)/)?.[1] ?? '';
}

export function convertLocalToTimezone(localDateTime: string, timeZone: string) {
  const date = fromZonedTime(localDateTime, timeZone);
  return isNaN(date.getTime()) ? localDateTime : date.toISOString();
}

export function convertTimezoneToLocal(utcDateTime: string, timeZone: string): string {
  const date = toZonedTime(utcDateTime, timeZone);
  return format(date, "yyyy-MM-dd'T'HH:mm:ss.SSS");
}
